var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('img',{attrs:{"src":_vm.url}}):_c('gl-sub-text',[_vm._v("読込中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }